import React from 'react';
import Home from './component/Home';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default App;